import React from "react";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

function Table({
  Head,
  children,
  counter,
  setCounter,
  data,
  paginationEnd,
  title,
}) {
  const lengthDivide = Math.ceil(data?.length / paginationEnd);

  const firstPageDirectly = () => setCounter(1);
  const prevPage = () => setCounter(counter > 1 ? counter - 1 : 1);
  const nextPage = () => setCounter(counter < lengthDivide ? counter + 1 : lengthDivide);
  const lastPageDirectly = () => setCounter(lengthDivide);

  const startPage = Math.max(1, counter - 2);
  const endPage = Math.min(lengthDivide, counter + 2);
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  // Count for current page display
  const StartValue = (counter - 1) * paginationEnd;
  const EndValue = Math.min(counter * paginationEnd, data?.length || 0);

  return (
    <div className={`w-full ${title === "user details" ? "pb-12" : ""}`}>
      <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px]" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr
                style={{
                  background: "linear-gradient(90deg, #0f172a 0%, #1e293b 60%, #312e81 100%)",
                }}
              >
                {Head?.map((val, i) => (
                  <th
                    key={i}
                    style={{ width: val.width || val.with }}
                    className={`text-left px-5 ${title === "adminInfoTable" ? "py-3" : "py-4"
                      } text-xs font-semibold text-slate-300 uppercase tracking-wider`}
                  >
                    {val.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">{children}</tbody>
          </table>
        </div>

        {lengthDivide > 1 && (
          <div className="flex flex-wrap gap-3 px-5 py-4 items-center justify-between bg-slate-50/80 border-t border-slate-100">
            {/* Result count */}
            <span className="text-sm text-slate-500">
              Showing{" "}
              <span className="font-semibold text-slate-700">{StartValue + 1}–{EndValue}</span>{" "}
              of{" "}
              <span className="font-semibold text-slate-700">{data?.length || 0}</span> results
            </span>

            {/* Page buttons */}
            <div className="flex items-center gap-1">
              <button
                className={`p-2 rounded-lg transition-colors ${counter === 1
                    ? "opacity-30 cursor-not-allowed text-slate-400"
                    : "text-slate-600 hover:bg-slate-200"
                  }`}
                onClick={firstPageDirectly}
                disabled={counter === 1}
              >
                <MdKeyboardDoubleArrowLeft className="w-5 h-5" />
              </button>
              <button
                className={`p-2 rounded-lg transition-colors ${counter === 1
                    ? "opacity-30 cursor-not-allowed text-slate-400"
                    : "text-slate-600 hover:bg-slate-200"
                  }`}
                onClick={prevPage}
                disabled={counter === 1}
              >
                <MdKeyboardArrowLeft className="w-5 h-5" />
              </button>

              <div className="flex gap-1 mx-1">
                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    className={`w-8 h-8 rounded-lg text-sm font-semibold transition-all duration-150 ${counter === page
                        ? "bg-secondMainColor text-white shadow-md"
                        : "text-slate-600 hover:bg-slate-200"
                      }`}
                    onClick={() => setCounter(page)}
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button
                className={`p-2 rounded-lg transition-colors ${counter === lengthDivide
                    ? "opacity-30 cursor-not-allowed text-slate-400"
                    : "text-slate-600 hover:bg-slate-200"
                  }`}
                onClick={nextPage}
                disabled={counter === lengthDivide}
              >
                <MdKeyboardArrowRight className="w-5 h-5" />
              </button>
              <button
                className={`p-2 rounded-lg transition-colors ${counter === lengthDivide
                    ? "opacity-30 cursor-not-allowed text-slate-400"
                    : "text-slate-600 hover:bg-slate-200"
                  }`}
                onClick={lastPageDirectly}
                disabled={counter === lengthDivide}
              >
                <MdKeyboardDoubleArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Table;
